import React, { useState, useEffect } from 'react';
import { styled } from '@volkswagen-onehub/components-core';
import { LiSection } from '.';
import { useWindowHeight, useWindowWidth } from '@react-hook/window-size';
import { useFaContent } from 'src/feature-app/hooks';
import { ModulProps } from 'src/feature-app/pages/CarouselPage';

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

interface WrapperProps {
  isVertical: boolean;
}

const UlWrapper = styled.ul<WrapperProps>`
  display: flex;
  min-height: ${(props)=> props.isVertical ? '50vh':'calc( 100vh - 52px )'};
  height: ${(props)=> props.isVertical ? '50vh':'calc( 100vh - 52px )'};
  margin: 0;
  padding: 0;
  overflow: hidden;
  list-style-type: none;
  @media all and (min-width: 1280px){
    min-height: ${(props)=> props.isVertical ? '50vh':'calc( 100vh - 52px )'};
  }
  @media all and (min-width: 1600px){
    min-height: ${(props)=> props.isVertical ? '50vh':'calc( 100vh - 52px )'};
  }

`;

interface BackgroundImagProps {
  liSection?: boolean;
  idLi?: number;
  isVertical: boolean;
}
export const BackgroundImage = styled.img<BackgroundImagProps>`
  position: absolute;
  top: ${(props) => props.liSection ? null : '0'};
  bottom: ${(props) => props.liSection ? '0' : null};
  left: ${(props) => props.idLi === 2 ? null : '0'};
  right:${(props) => props.idLi === 2 ? '0' : null};
  width: auto;
  height: ${(props)=> props.isVertical ? '50vh':'100vh'};
  transform-origin: ${(props) => props.liSection && props.idLi === 2 ? 'right bottom' : props.liSection  ? 'left bottom' : null};
  transform: ${(props) => props.idLi === 0 ? 'scale(1.2) translateX(-20%)' : props.idLi === 1 ? 'scale(1.2) translateX(-35%)' : props.idLi === 2 ? 'scale(1.2)' : null};

  min-width: 100vw;
  min-height: ${(props)=> props.isVertical ? '50vh':'100vh'};
  @media all and (min-width: 1280px){
    min-height: ${(props)=> props.isVertical ? '50vh':'100vh'};
  }
  @media all and (min-width: 1600px){
    min-height: ${(props)=> props.isVertical ? '50vh':'100vh'};
  }
`;

export const AcordionHorizontal = (props: ModulProps) => {
  const faContent = useFaContent();
  const { carlinesWithOffers } = props;
  const height = useWindowHeight();
  const width = useWindowWidth();
  const [active, setActive] = useState(0);
  const [isVertical, setVertical] = useState<boolean>(false);

  useEffect(()=>{
    if(width - height <= 100 || height > width) {
      setVertical(true);
    } else {
      setVertical(false);
    }
  },[width]);

  const handleClick = (e:any, index:number) => {
    e.preventDefault();
    if (active === index) {
      return;
    } else {
      setActive(index);
    }
  };

  return (
    <Wrapper >
      {
        faContent.imageUrl &&< BackgroundImage src={faContent.imageUrl} isVertical={isVertical}/>
      }
      
      <UlWrapper isVertical={isVertical}>
        {
          carlinesWithOffers.ofertas.map((o, i) => {
            return <LiSection theme={faContent.theme} backgroundImageUrl={faContent.imageUrl ? faContent.imageUrl : null } numberOfOffers={carlinesWithOffers.ofertas.length} active={active} handleClick={handleClick} id={i} offer={o} />;
          })
        }
      </UlWrapper>
    </Wrapper>
  );
};
